const sanitizeCell = (value) => {
    const escaped = String(value ?? '').replace(/"/g, '""');
    // Prefix formula-trigger characters to prevent CSV injection
    return /^[=+\-@\t\r]/.test(escaped) ? `"'${escaped}"` : `"${escaped}"`;
};
export const buildCsv = (headers, data) => [headers.map(sanitizeCell), ...data.map((row) => headers.map((h) => sanitizeCell(row[h])))]
    .map((row) => row.join(','))
    .join('\n');
